"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-a746f0fc"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "searchPile" };
const _hoisted_2 = {
    key: 0,
    class: "modelContent"
};
const _hoisted_3 = { class: "advancedQueryModel" };
const index_1 = require("../../service/index");
const index_2 = require("../../utils/index");
const vue_3 = require("vue");
const productionFormFields_1 = __importDefault(require("./productionFormFields"));
const deviceFormFields_1 = __importDefault(require("./deviceFormFields"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    props: {
        customSearchMethod: {
            type: Boolean,
            default: false
        },
        selectValue: String,
        productionOrDevice: Number,
        selectClass: String,
        openAdvancedQuery: {
            type: Boolean,
            default: false
        }
    },
    emits: ['searchCode', 'advancedQuery', 'searchKeywords'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const SN = (0, vue_3.ref)();
        const stakeQRCode = (0, vue_3.ref)();
        const deviceSN = (0, vue_3.ref)();
        const selectOption = (0, vue_3.ref)();
        const options = (0, vue_3.ref)();
        const selectValue = (0, vue_3.ref)(props.selectValue);
        const showQueryModel = (0, vue_3.ref)();
        const currentFormFields = (0, vue_3.ref)(productionFormFields_1.default);
        const formOptions = (0, vue_3.ref)({});
        const onSelectChange = (_value, option, item) => {
            if (item.name === "suyuanqijiansn") {
                formState.chengpinsnma = option.chengpinsnma;
            }
        };
        const onSelectSearch = (value, item) => __awaiter(this, void 0, void 0, function* () {
            switch (item.name) {
                case "chengpinsnma": {
                    const { suyuanqijianwuliaobianma, pici, suyuanqijianwuliaomingcheng, suyuanqijiansn } = formState;
                    const response = yield (0, index_1.queryByCpSnKeywords)({
                        [item.paramKey || item.name]: (0, index_2.montageSN)(value),
                        lailiaopici: pici || undefined,
                        suyuanqijianwuliaobianma: suyuanqijianwuliaobianma || undefined,
                        suyuanqijianwuliaomingcheng: suyuanqijianwuliaomingcheng || undefined,
                        suyuanqijiansn: suyuanqijiansn || undefined,
                    });
                    formOptions.value[item.name] = ((response === null || response === void 0 ? void 0 : response.data) || []).map((item) => ({
                        label: item,
                        value: item,
                    }));
                    break;
                }
                case "suyuanqijiansn": {
                    if (props.customSearchMethod) {
                        const { suyuanqijianwuliaobianma, pici, suyuanqijianwuliaomingcheng, chengpinsnma } = formState;
                        // 自定义搜索关键字得方法
                        emit('searchKeywords', {
                            keywords: value,
                            suyuanqijianwuliaobianma: suyuanqijianwuliaobianma || undefined,
                            lailiaopici: pici || undefined,
                            suyuanqijianwuliaomingcheng: suyuanqijianwuliaomingcheng || undefined,
                            chengpinsnma: chengpinsnma || undefined,
                            callback: (data) => {
                                formOptions.value[item.name] = data;
                            }
                        });
                    }
                    else {
                        const res = yield (0, index_1.searchDeviceSN)(value);
                        formOptions.value[item.name] = ((res === null || res === void 0 ? void 0 : res.data) || []).map((item) => ({
                            label: item,
                            value: item,
                        }));
                    }
                    break;
                }
            }
        });
        const getFormState = (list) => {
            const obj = {};
            list.forEach((item) => {
                obj[item.name] = "";
            });
            return obj;
        };
        const formState = (0, vue_3.reactive)(getFormState(currentFormFields.value));
        const onFinish = (values) => {
            emit('advancedQuery', values);
        };
        const onSearch = (0, index_2.antiShake)((value) => __awaiter(this, void 0, void 0, function* () {
            if (props.productionOrDevice === 0) {
                const res = yield (0, index_1.searchSN)(value);
                options.value = ((res === null || res === void 0 ? void 0 : res.data) || []).map((item) => {
                    return {
                        label: item,
                        value: item,
                    };
                });
            }
            else {
                if (props.customSearchMethod) {
                    // 自定义搜索关键字得方法
                    emit('searchKeywords', {
                        keywords: value,
                        callback: (data) => {
                            options.value = data;
                        }
                    });
                }
                else {
                    const res = yield (0, index_1.searchDeviceSN)(value);
                    options.value = ((res === null || res === void 0 ? void 0 : res.data) || []).map((item) => {
                        return {
                            label: item,
                            value: item,
                        };
                    });
                }
            }
        }), 500);
        const onChange = (value) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            selectValue.value = value;
            selectOption.value = (options.value || []).find(item => item.value === value);
            if (props.productionOrDevice === 0) {
                const res = yield (0, index_1.getBaseInfo)(value);
                SN.value = (_a = res.data.find((item) => item.label === '产品SN码')) === null || _a === void 0 ? void 0 : _a.value;
                stakeQRCode.value = (_b = res.data.find((item) => item.label === '桩二维码')) === null || _b === void 0 ? void 0 : _b.value;
            }
            else {
                deviceSN.value = value;
            }
        });
        (0, vue_3.watch)(() => props.productionOrDevice, () => {
            selectValue.value = null;
            options.value = [];
            currentFormFields.value = props.productionOrDevice === 0 ? productionFormFields_1.default : deviceFormFields_1.default;
        });
        return (_ctx, _cache) => {
            const _component_a_select = (0, vue_2.resolveComponent)("a-select");
            const _component_a_button = (0, vue_2.resolveComponent)("a-button");
            const _component_a_input = (0, vue_2.resolveComponent)("a-input");
            const _component_a_form_item = (0, vue_2.resolveComponent)("a-form-item");
            const _component_a_form = (0, vue_2.resolveComponent)("a-form");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (props.openAdvancedQuery)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 0,
                            class: "highLevel",
                            onClick: _cache[0] || (_cache[0] = ($event) => (showQueryModel.value = !showQueryModel.value))
                        }, " 高级查询 "))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createVNode)(_component_a_select, {
                        allowClear: "",
                        "show-search": "",
                        class: (0, vue_2.normalizeClass)(`search  ${__props.selectClass}`),
                        placeholder: __props.productionOrDevice === 0 ? '请输入产品SN码或桩二维码' : '请输入溯源器件SN码',
                        onSearch: _cache[1] || (_cache[1] = (value) => { (0, vue_2.unref)(onSearch)(value); }),
                        options: options.value,
                        onChange: _cache[2] || (_cache[2] = (value) => { onChange(value); }),
                        value: selectValue.value,
                        disabled: showQueryModel.value
                    }, null, 8, ["class", "placeholder", "options", "value", "disabled"]),
                    (0, vue_2.createVNode)(_component_a_button, {
                        type: "primary",
                        onClick: _cache[3] || (_cache[3] = ($event) => (emit('searchCode', { SN: SN.value, stakeQRCode: stakeQRCode.value, deviceSN: deviceSN.value, selectOption: selectOption.value }))),
                        disabled: showQueryModel.value
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createTextVNode)("立即查询")
                        ]),
                        _: 1
                    }, 8, ["disabled"])
                ]),
                (showQueryModel.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (0, vue_2.createVNode)(_component_a_form, {
                                model: formState,
                                name: "basic",
                                "label-col": { span: 6 },
                                "wrapper-col": { span: 18 },
                                autocomplete: "off",
                                onFinish: onFinish
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(currentFormFields.value, (item) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_a_form_item, {
                                            label: item.label,
                                            name: item.name
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (!item.type || item.type === 'input')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_a_input, {
                                                        key: 0,
                                                        value: formState[item.name],
                                                        "onUpdate:value": ($event) => ((formState[item.name]) = $event),
                                                        allowClear: ""
                                                    }, null, 8, ["value", "onUpdate:value"]))
                                                    : (item.type === 'select')
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_a_select, {
                                                            key: 1,
                                                            ref_for: true,
                                                            ref: "select",
                                                            value: formState[item.name],
                                                            "onUpdate:value": ($event) => ((formState[item.name]) = $event),
                                                            "show-search": "",
                                                            onSearch: (value) => { onSelectSearch(value, item); },
                                                            onChange: (value, option) => onSelectChange(value, option, item),
                                                            options: item.options || formOptions.value[item.name],
                                                            allowClear: ""
                                                        }, null, 8, ["value", "onUpdate:value", "onSearch", "onChange", "options"]))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                            ]),
                                            _: 2
                                        }, 1032, ["label", "name"]));
                                    }), 256)),
                                    (0, vue_2.createVNode)(_component_a_form_item, { "wrapper-col": { offset: 8, span: 16 } }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createVNode)(_component_a_button, {
                                                type: "primary",
                                                "html-type": "submit"
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createTextVNode)("查询")
                                                ]),
                                                _: 1
                                            }),
                                            (0, vue_2.createTextVNode)("     "),
                                            (0, vue_2.createVNode)(_component_a_button, {
                                                type: "primary",
                                                onClick: _cache[4] || (_cache[4] = ($event) => (showQueryModel.value = false))
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createTextVNode)("关闭")
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["model"])
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
